<template>
  <nav class="navbar bg-nav">
    <router-link to="/home">
      <img class="bs-logo" src="@/assets/images/icons/bs-logo-beta.svg">
    </router-link>

    <section class="menu-right">

      <router-link to="/new-script">
        <img class="new-script-button" src="@/assets/images/icons/add-black.svg">
      </router-link>


      <div class="user-menu">
        <img class="hamburger" v-on:click="showMenu = true" src="@/assets/images/icons/hamburger.svg">

        <div class="slideout-menu" v-on:click="showMenu = false" v-bind:class="{ visible : showMenu }">

          <div class="arrow-container">
            <img class="arrow-right" src="@/assets/images/icons/keyboard-arrow-right-white.svg">
          </div>

          <section v-on:click="openProProfile()" class="menu-top">
            <div v-if="currentUser.hasAvatar" class="profile-image">
              <img v-bind:src="currentUser.avatarThumbnail" class="user-image fade-hover">
            </div>
            <div v-else class="profile-image">
              <img src="@/assets/images/no-profile-image.png" class="user-image">
            </div>

            <div class="user-info">
              <span class="truncate">{{ currentUser.fullName() }}</span>
              <span class="truncate">{{ currentUser.hometown() }}</span>
              <span class="truncate grayed">{{ currentUser.profession }}</span>
              <span class="truncate grayed">{{ currentUser.personalUrl }}</span>
              <span class="truncate grayed">My Bx Profile</span>
            </div>
          </section>

          <router-link to="/user-profile">{{capitalize("Scripts")}}</router-link>
          <router-link to="/user-settings">{{capitalize("Settings")}}</router-link>
          <router-link to="/analytics">{{capitalize("analytics")}}</router-link>
          <TermsLink text="TERMS OF SERVICE" />
          <a href="https://blog.beautyscripts.com/support" target="_blank">{{capitalize("help")}}</a>
          <!-- <router-link to="/refer">{{capitalize("refer a pro")}}</router-link> -->
          <a href="http://blog.beautyscripts.com" target="_blank">{{capitalize("bx journal")}}</a>
          <a href="#" v-on:click="logout">{{capitalize("Logout")}}</a>
        </div>
      </div>

    </section>

  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import TermsLink from '@/components/utilities/TermsLink'

export default {
  name: 'Navbar',
  components: {
    TermsLink
  },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {
    openProProfile () {
      const url = window.location.origin + '/' + this.currentUser.identifier
      window.open(url, '_blank')
    },
    logout () {
      this.$store.dispatch('logout')
      delete localStorage.token
      this.$router.replace(this.$route.query.redirect || '/login')
    }
  }
}
</script>

<style lang="scss" scoped>

.bg-nav {
  background:                 #F8F8F8;
  border-bottom:              1px solid #DEDEDE;
  width:                      100%;
  padding:                    0.5em 1.5em;
  position:                   fixed;
  height:                     3.6em;
  z-index:                    999998;
  width:                      100%;

  .bs-logo {
    width:                    2em;
    height:                   2em;
  }

  .menu-right {

    margin-right:             0.5em;

    .new-script-button {
      height:                 1.75em;
      width:                  1.75em;
      margin-right:           1em;
    }
  }
}

.btn-logout {
  background-color:           #837A75;
  border-color:               #837A75;
  color:                      #fff;
}

.btn-logout:hover {
  opacity:                    0.8;
}

.user-menu {
  position:                   relative;
  display:                    inline-block;
  cursor:                     pointer;

  .hamburger {
    height:                   1em;
    width:                    1em;
  }

  .slideout-menu {
    transition:               transform 1s;
    transform:                translateX(100%);
    position:                 fixed;
    top:                      0;
    bottom:                   0;
    right:                    0;
    padding:                  1em;
    z-index:                  999998; // Only sits behind modals
    background-color:         black;
    color:                    #FFFFFF;
    width:                    25%;
    min-width:                20em;
    font-size:                0.8em;
    overflow:                 scroll;

    &.visible {
      transform:              translateX(0%);
    }

    .arrow-container {
      text-align:             right;

      > img {
        width:                1.5em;
        height:               1.5em;
      }
    }

    .menu-top {
      display:                flex;
      align-items:            center;

      .profile-image {
        width:                50%;
        display:              inline-block;
        padding:              1em;

        > img {
          width:              100%;
          border-radius:      50%;
          max-height:         8em;
          max-width:          8em;
        }
      }

      .user-info {
        width:                50%;
        display:              inline-block;
        line-height:          1.2em;

        > span {
          display:            block;
        }

        .grayed {
          color:              #9C9C9C;

          > a {
            color:            #9C9C9C;
            text-decoration:  none;
          }
        }
      }
    }

    > a {
      color:                  white;
      padding:                1em;
      display:                block;
      border-bottom:          1px solid #9C9C9C;

      &:last-of-type {
        border-bottom:        none;
      }
    }
  }

  .fa-user-o {
    font-size:                2em;
  }

}



/* Landscape phone to portrait tablet */
@media (max-width: 767px) {

  .bg-nav {
    padding:                  0.5em 1em;
  }

  .user-menu {

    .slideout-menu {
      padding:                2em;
      width:                  100%;
      font-size:              0.8em;

      > a {
        padding:              1.5em;
      }

      .menu-top {

        .profile-image {
          width:              auto;

          > img {
            max-width:        10em;
            max-height:       10em;
          }
        }

        .user-info {
          line-height:        1.4em;
        }
      }
    }
  }
}

/* Landscape phones and down */
@media (max-width: 480px) {

  .user-menu {

    .slideout-menu {
      .menu-top {

        .profile-image {

          > img {
            max-width:        7em;
            max-height:       7em;
          }
        }
      }
    }
  }

}

/* Portrait tablet to landscape and desktop */
@media (min-width: 768px) and (max-width: 979px) {

}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue